import { Resolve, Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { IOpportunity } from "../../../shared/model/opportunity.model";
import { OrganizationService } from "../../../core/service/organization.service";
import { IOrganization } from "../../../shared/model/organization.model";
import { IPastTermEnrollment, IPastTermRegistrationResolverData } from "../past-term-registration-form.model";
import { IUserInfoComplete } from "../../../shared/model/userInfo.model";
import { AuthService } from "../../../core/service/auth.service";
import { AuditService } from "../../../core/service/audit.service";
import {QuestionService} from "../../../core/service/question.service";
import {EvaluationQuestion} from "../../../shared/model/evaluation-model";


@Injectable({ providedIn: 'root' })
export class PastTermRegistrationFormResolver implements Resolve<IPastTermRegistrationResolverData | undefined> {

  private userData?: IUserInfoComplete;
  private opportunity?: IOpportunity;
  private organizationData?: IOrganization;
  private pastTermEnrollmentData?: IPastTermEnrollment[];
  private evaluationQuestionsData?: EvaluationQuestion[];

  constructor(
    private router: Router,
    private authService: AuthService,
    private organizationService: OrganizationService,
    private auditService: AuditService,
    private questionService: QuestionService) {}

  async resolve(): Promise<IPastTermRegistrationResolverData | undefined> {
    const routerState = this.router.getCurrentNavigation()?.extras.state;
    this.userData = await this.getUserData();
    this.opportunity = routerState ? routerState['opportunity'] : undefined;
    this.organizationData = await this.getOrganizationData();
    this.pastTermEnrollmentData = await this.getEligiblePastEnrollments();
    this.evaluationQuestionsData = await this.getEvaluationQuestions();

    return {
      userData: this.userData,
      organizationData: this.organizationData,
      pastTermEnrollmentsData: this.pastTermEnrollmentData,
      evaluationQuestionsData: this.evaluationQuestionsData
    } as IPastTermRegistrationResolverData;
  }

  private async getUserData(): Promise<IUserInfoComplete | undefined> {
    return await firstValueFrom(this.authService.getCurrentUserInfo());
  }

  private async getOrganizationData(): Promise<IOrganization | undefined> {
    if (!this.opportunity) return undefined;
    return await firstValueFrom(this.organizationService.getOrganization(this.opportunity.organizationId));
  }

  private async getEligiblePastEnrollments(): Promise<IPastTermEnrollment[]> {
    return await firstValueFrom(this.auditService.getPastTermEnrollments());
  }

  private async getEvaluationQuestions(): Promise<EvaluationQuestion[]> {
    return await firstValueFrom(this.questionService.getQuestions());
  }

}
